import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
    selector: 'app-standard-toggle-switch-tristate',
    templateUrl: './standard-toggle-switch-tristate.component.html',
    styleUrls: ['./standard-toggle-switch-tristate.component.scss'],
    standalone: false,
})
export class StandardToggleSwitchTriStateComponent implements ControlValueAccessor {
    public control = inject(NgControl, { self: true, optional: true });

    @Input() public label: string;
    @Input() public disabled = false;
    @Input() public checked: boolean = null;
    @Input() public toggledLabel = 'True';
    @Input() public notToggledLabel = 'False';
    @Input() public neutralToggledLabel = 'Keep';
    @Output() public toggleChanged = new EventEmitter<boolean>();

    public id: string;
    public background_blue: boolean;

    constructor() {
        if (this.control) {
            this.control.valueAccessor = this;
        }
        this.background_blue = false;
    }

    public onChangeFn = (_: boolean) => {
        return;
    };

    public onTouchedFn = () => {
        return;
    };

    public writeValue(value: boolean | number): void {
        this.checked = value != null && !Number.isNaN(value) ? value === true || value === 1 : null;
        this.background_blue = value === true;
    }

    public registerOnChange(fn: () => void): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public onChange(value: boolean) {
        this.background_blue = value === true;
        this.onChangeFn(value);
        this.toggleChanged.emit(value);
    }
}
